// @ts-nocheck

import React, { useState } from 'react';
import {
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from '@chakra-ui/react';

interface InputNumberProps {
  min: number;
  max: number;
  step: number;
  getValue: any;
  value: number;
}

export default function InputNumber({
  max,
  min,
  step,
  getValue,
  value,
}: InputNumberProps) {
  return (
    <NumberInput
      value={value}
      onChange={event => {
        getValue(event);
      }}
      min={min}
      max={max}
      step={step}
    >
      <NumberInputField />
      <NumberInputStepper>
        <NumberIncrementStepper />
        <NumberDecrementStepper />
      </NumberInputStepper>
    </NumberInput>
  );
}
